import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Grid, Icon, IconButton } from '@mui/material'
import { QuantitySelector } from 'components'
import { formatNumber } from 'core/lib'

function Product({ product }) {
	const cartImage = useRef(null)
	const dispatch = useDispatch()
	const shop = useSelector(state => state.shop)

	const setQuantity = (quantity) => {
		dispatch({ type: 'updateQuantity@cart', product: product, quantity: quantity })
	}

	const removeProduct = () => {
		if (window.confirm('Rimuovere il prodotto dal carrello ?')) {
			dispatch({ type: 'removeProduct@cart', product: product })
		}
	}

	return (<div className="product">
		<Grid container spacing={1}>
			<Grid item xs={12}>
				{product.html_title && product.html_title != '' && <div className="name" dangerouslySetInnerHTML={{
					__html: product.html_title
				}}></div>}
			</Grid>
			<Grid item xs={3} sm={2}>
				<div className="pic" ref={cartImage} style={{ height: cartImage.current ? cartImage.current.getBoundingClientRect().width : 0 }}>
					<img src={`${window.__endpoint}/images/products/m/${product.main_image ? product.main_image.image_id : 'missing'}.jpg`} alt={product.name} />
				</div>
			</Grid>
			<Grid item xs={9} sm={10}>
				{product.options && product.options.length > 0 && <div className="options">
					{product.options.map((option, o) => <div key={o}  className="option">
						{option.name}: {option.values.map(value => value.value).join(', ')}
					</div>)}
				</div>}

				<div className="price">{formatNumber(product.price)} €</div>
				{shop.profiles.ueby_item_quantity_check == 1 && <div className="availability">
					<span className="label">Disponibilità:</span> {product.availableQuantity}
				</div>}
				<div className="quantity">
					<QuantitySelector
						quantity={product.quantity}
						setQuantity={setQuantity}
						availableQuantity={shop.profiles.ueby_item_quantity_check == 1 ? product.availableQuantity : null}
					/>
					<IconButton color="primary" aria-label="elimina" component="span" className="delete" onClick={removeProduct} style={{ float: 'right' }}>
						<Icon>delete</Icon>
					</IconButton>
				</div>
			</Grid>
		</Grid>
	</div>)
}

export default Product
